import { render, staticRenderFns } from "./ChangeCourseRequests.vue?vue&type=template&id=20d3397c"
import script from "./ChangeCourseRequests.vue?vue&type=script&lang=ts"
export * from "./ChangeCourseRequests.vue?vue&type=script&lang=ts"
import style0 from "./ChangeCourseRequests.vue?vue&type=style&index=0&id=20d3397c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports